import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user-store'
import AppLayout from '@/layouts/AppLayout.vue'
import RouteViewComponent from '@/layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    name: 'root',
    path: '/',
    component: AppLayout,
    redirect: { name: 'autoData' },
    children: [
      {
        path: 'auto-data',
        name: 'autoData',
        component: () => import('@/pages/auto_data/AutoDataPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: RouteViewComponent,
    meta: { Auth: true },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/pages/auth/LoginPage.vue'),
      },
    ],
  },
  {
    path: '/error',
    meta: { Error: true },
    children: [
      {
        name: '404',
        path: '404',
        component: () => import('@/pages/errors/NotFoundPage.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: '404' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const store = useUserStore()
  if (to.meta.Auth) {
    if (store.exists) {
      return next({ name: 'autoData' })
    } else {
      return next()
    }
  }

  const currentUser = await store.getMe()

  if (!currentUser) {
    return next({ name: 'login' })
  }
  return next()
})

export default router
